import { imageLoadError, form } from '../state'

/**
 * Görsel yüklemesini yeniler
 * Görsel URL aynı olsa bile yeniden yüklenmesini sağlar
 */
export const reloadImage = () => {
  if (!form.currentImageUrl) return

  // Görsel URL aynı olsa bile yeniden yüklenmesi için 
  // önce hata durumunu sıfırla ve geçici olarak URL'i kaldır
  imageLoadError.value = false
  const tempUrl = form.currentImageUrl
  form.currentImageUrl = ''

  // Bir sonraki tick'te tekrar görseli yükle
  setTimeout(() => {
    form.currentImageUrl = tempUrl
  }, 100)
}

/**
 * Görsel yükleme hatası durumunda çağrılacak handler
 * @param {Event} event - Görsel yükleme hatası eventi (opsiyonel)
 */
export const handleImageError = (event = null) => {
  console.log('Görsel yükleme hatası oluştu', event)
  imageLoadError.value = true
}
